

































import { Component, Vue, Prop } from "vue-property-decorator";
import ServiceContainer from "@flashpointbv/solar-service-container";

@Component({
  name: "global-dialog",
  components: ServiceContainer().getComponents(),
})
export default class GlobalDialog extends Vue {
  @Prop({ type: String, default: "" }) titleClass!: string;
  @Prop({ type: String, default: "" }) customDialogClass!: string;
  @Prop({ type: String, default: "" }) customComponentClass!: string;
  @Prop({ type: Boolean, default: true }) closeOnBackdropClick!: boolean;
  @Prop({ type: Boolean, default: true }) closeOnEscape!: boolean;
  private isOpen: boolean = false;

  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
  }

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown);
  }

  private handleKeydown(event: KeyboardEvent): void {
    if (event.key === "Escape" && this.isOpen && this.closeOnEscape) {
      this.closeDialog();
    }
  }

  private openDialog(): void {
    const dialog = this.$refs.dialog as HTMLDialogElement;
    if (dialog) {
      dialog.showModal();
      this.isOpen = true;
      document.body.style.overflow = "hidden";
    }
  }

  private closeDialog(): void {
    const dialog = this.$refs.dialog as HTMLDialogElement;
    if (dialog) {
      dialog.close();
      this.isOpen = false;
      document.body.style.removeProperty("overflow");
    }
  }

  private handleOutsideClick(event: MouseEvent): void {
    if (!this.closeOnBackdropClick) {
      return;
    }
    const dialog = this.$refs.dialog as HTMLDialogElement;
    const dialogContent = this.$el.querySelector('.dialog__content');
    if (dialog && dialogContent && !dialogContent.contains(event.target as Node)) {
      this.closeDialog();
    }
  }
}
